import { Building2 } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { buildAutomationEditPath } from '../../../../../app-routes';
import { Button } from '../../../../../components/ui/button';
import { TemplateStatusPill } from '../template-status-pill/TemplateStatusPill';
import type { TemplateListRow } from '../types';
import { CopyTemplateButton } from './CopyTemplateButton';
import { SubscribedTenantsDialog } from './SubscribedTenantsDialog';
import styles from './templates-table.module.css';

export function TemplatesTableRow({
  template,
  displayName,
  description,
  status,
  templateSubscriberCount,
  activeBusinessIds,
}: TemplateListRow) {
  const navigate = useNavigate();
  const [showTenants, setShowTenants] = useState(false);

  const templateHasSubscribers = templateSubscriberCount > 0;

  const handleEditTemplate = () => {
    navigate(buildAutomationEditPath(template.id));
  };

  return (
    <tr className={styles.tableRow} onClick={handleEditTemplate}>
      <td className={styles.nameCell}>
        <span className={styles.name}>{displayName}</span>
        {description && <span className={styles.description}>{description}</span>}
      </td>
      <td>
        {templateHasSubscribers ? (
          <button
            type="button"
            className={styles.tenantsUsingButton}
            onClick={event => {
              event.stopPropagation();
              setShowTenants(true);
            }}>
            <Building2 className={styles.tenantsIcon} />
            {templateSubscriberCount}
          </button>
        ) : (
          <span className={styles.tenantsUsingZero}>0</span>
        )}
        {showTenants && (
          <SubscribedTenantsDialog
            title="Tenants using"
            templateName={displayName}
            activeBusinessIds={activeBusinessIds}
            onClose={() => setShowTenants(false)}
          />
        )}
      </td>
      <td>
        <TemplateStatusPill status={status} />
      </td>
      <td onClick={event => event.stopPropagation()}>
        <Button onClick={handleEditTemplate} variant="ghost" size="sm" className={styles.editButton}>
          Edit
        </Button>
        <CopyTemplateButton template={template} />
      </td>
    </tr>
  );
}
